export default "__VITE_ASSET__Drsx5RKA__"